import Hero from "../components/sections/Hero";
import Services from "../components/sections/Services";
import StatsMarquee from "../components/sections/StatsMarquee";
import Process from "../components/sections/Process";
import PortfolioGrid from "../components/sections/PortfolioGrid";
import Testimonials from "../components/sections/Testimonials";
import Pricing from "../components/sections/Pricing";
import CTASection from "../components/sections/CTASection";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <StatsMarquee />
      <Services />
      <PortfolioGrid />
      <Process />
      <Testimonials />
      <Pricing />
      <CTASection />
    </div>
  );
}
